import Link from 'next/link';
import Tab from '@mui/material/Tab';

type Props = {
  as?: string;
  href?: string;
  value?: string;
};

const LinkTab = ({ as: linkAs, href, value, ...rest }: Props) => {
  return (
    <Tab
      key={value}
      value={value}
      component={Link}
      href={linkAs || href}
      {...rest}
    />
  );
};

export default LinkTab;
